export default __webpack_public_path__ + "static/12-dd64657ef6bef41cda0cf884f8648188.png";